module.exports = __webpack_public_path__ + "static/media/resources0763a18c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sidenav/images/resources.svg
// module id = 1233
// module chunks = 0